
import { z } from 'zod';

export const NotificationSettingsSchema = z.object({
  listingAdded: z.boolean().default(true),
  bookingCreated: z.boolean().default(true),
  listingUpdated: z.boolean().default(true),
});

export type NotificationSettings = z.infer<typeof NotificationSettingsSchema>;

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings =
  NotificationSettingsSchema.parse({});

export function parseNotificationSettings(raw: unknown): NotificationSettings {
  const result = NotificationSettingsSchema.safeParse(raw ?? {});
  return result.success ? result.data : { ...DEFAULT_NOTIFICATION_SETTINGS };
}
